import { action } from 'typesafe-actions';
import { IEnvelope, IBlock, ISignatureSettings, ISigner } from './types';
import { IBlockState } from './reducers/blocks';
import { IGroupState } from './reducers/groups';

export enum ActionTypes {
  ERROR = 'ERROR',
  FETCH_ENVELOPE = 'FETCH_ENVELOPE',
  FETCH_ENVELOPE_DONE = 'FETCH_ENVELOPE_DONE',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT',
  SIGN_FIELD = 'SIGN_FIELD',
  SHOW_SIGNATURE_MODAL = 'SHOW_SIGNATURE_MODAL',
  CLOSE_SIGNATURE_MODAL = 'CLOSE_SIGNATURE_MODAL',
  CANCEL_SIGNATURE_MODAL = 'CANCEL_SIGNATURE_MODAL',
  CONFIRM_SIGNATURE_MODAL = 'CONFIRM_SIGNATURE_MODAL',
  CONFIRM_SIGNATURE_MODAL_DONE = 'CONFIRM_SIGNATURE_MODAL_DONE',
  CHANGE_SIGNATURE_TEXT = 'CHANGE_SIGNATURE_TEXT',
  SUBMIT_ENVELOPE = 'SUBMIT_ENVELOPE',
  SUBMIT_ENVELOPE_DONE = 'SUBMIT_ENVELOPE_DONE',
  TERMS_ACCEPTED = 'TERMS_ACCEPTED',
  SUBMIT_ESIGN_DISCLOSURE = 'SUBMIT_ESIGN_DISCLOSURE',
  SUBMIT_ESIGN_DISCLOSURE_DONE = 'SUBMIT_ESIGN_DISCLOSURE_DONE',
  START_REQUEST = 'START_REQUEST',
  END_REQUEST = 'END_REQUEST',
  DOWNLOAD_DOCUMENTS = 'DOWNLOAD_DOCUMENTS',
  FETCH_PRESIGNED_URLS = 'FETCH_PRESIGNED_URLS',
  FETCH_PRESIGNED_URLS_DONE = 'FETCH_PRESIGNED_URLS_DONE',
  UPDATE_BLOCK = 'UPDATE_BLOCK',
  FETCH_THUMBNAILS_BY_ENVELOPE = 'FETCH_THUMBNAILS_BY_ENVELOPE',
  FETCH_THUMBNAILS_BY_ENVELOPE_DONE = 'FETCH_THUMBNAILS_BY_ENVELOPE_DONE',
  ADD_BLOCKS_TO_SIGNING_EXPERIENCE = 'ADD_BLOCKS_TO_SIGNING_EXPERIENCE',
  SIGNING_EXPERIENCE_COMPLETE = 'SIGNING_EXPERIENCE_COMPLETE',
  TAB_NEXT_BLOCK = 'TAB_NEXT_BLOCK',
  TAB_TO_BLOCK = 'TAB_TO_BLOCK',
  UPDATE_SIGNING_EXPERIENCE_BLOCK = 'UPDATE_SIGNING_EXPERIENCE_BLOCK',
  DOWNLOAD_ENVELOPE = 'DOWNLOAD_ENVELOPE',
  DOWNLOAD_ENVELOPE_DONE = 'DOWNLOADED_ENVELOPE_DONE',
  SHOW_EXIT_SIGNING_MODAL = 'SHOW_EXIT_SIGNING_MODAL',
  CLOSE_EXIT_SIGNING_MODAL = 'CLOSE_EXIT_SIGNING_MODAL',
  SET_PAGE_DIMENSIONS = 'SET_PAGE_DIMENSIONS',
  SET_PAGE_SCALE = 'SET_PAGE_SCALE',
  COMPLETE_BLOCKS_IN_GROUP = 'COMPLETE_BLOCKS_IN_GROUP',
  SET_CURRENT_DOCUMENT = 'SET_CURRENT_DOCUMENT',
  SET_PENDING_BLOCK_INFO = 'SET_PENDING_BLOCK_INFO',
  UPDATE_SIGNER_SIGNING_SETTINGS = 'UPDATE_SIGNER_SIGNING_SETTINGS',
}
export const showExitSigningModal = () => action(ActionTypes.SHOW_EXIT_SIGNING_MODAL);
export const closeExitSigningModal = () => action(ActionTypes.CLOSE_EXIT_SIGNING_MODAL);
export const error = (error: string) => action(ActionTypes.ERROR, error);
export const fetchEnvelope = (envelopeId: string, signerId: string) =>
  action(ActionTypes.FETCH_ENVELOPE, { envelopeId, signerId });
export const fetchEnvelopeDone = (envelope: IEnvelope) => action(ActionTypes.FETCH_ENVELOPE_DONE, envelope);
export const zoomIn = () => action(ActionTypes.ZOOM_IN);
export const zoomOut = () => action(ActionTypes.ZOOM_OUT);

export const signField = (documentId: string, pageNumber: number, blockId: string) =>
  action(ActionTypes.SIGN_FIELD, { documentId, pageNumber, blockId });

export const showSignatureModal = (documentId?: string, pageNumber?: number, blockId?: string) =>
  action(ActionTypes.SHOW_SIGNATURE_MODAL, { documentId, pageNumber, blockId });

export const closeSignatureModal = () => action(ActionTypes.CLOSE_SIGNATURE_MODAL);
export const cancelSignatureModal = () => action(ActionTypes.CANCEL_SIGNATURE_MODAL);
export const updateBlock = (documentId: string, pageNumber: number, blockId: string, blockUpdate: any) =>
  action(ActionTypes.UPDATE_BLOCK, { documentId, pageNumber, blockId, blockUpdate });

export const submitEnvelope = (envelopeId: string, signerId: string, data: object, signatureFont: string|undefined, signer:ISigner) =>
  action(ActionTypes.SUBMIT_ENVELOPE, { envelopeId, signerId, data, signatureFont, signer });
export const submitEnvelopeDone = () => action(ActionTypes.SUBMIT_ENVELOPE_DONE);
export const termsAccepted = () => action(ActionTypes.TERMS_ACCEPTED);
export const submitEsignDisclosure = (envelopeId: string, signerId: string) =>
  action(ActionTypes.SUBMIT_ESIGN_DISCLOSURE, { envelopeId, signerId });
export const submitEsignDisclosureDone = () => action(ActionTypes.SUBMIT_ESIGN_DISCLOSURE_DONE);
export const confirmSignatureModal = (
  envelopeId: string,
  documentId: string,
  pageNumber: number,
  blockId: string,
  signerId: string,
  signatureSettings: ISignatureSettings,
  useExistingSettings?: boolean,
) =>
  action(ActionTypes.CONFIRM_SIGNATURE_MODAL, {
    pageNumber,
    documentId,
    envelopeId,
    signerId,
    blockId,
    signatureSettings,
    useExistingSettings
  });
export const confirmSignatureModalDone = () => action(ActionTypes.CONFIRM_SIGNATURE_MODAL_DONE);
export const startRequest = () => action(ActionTypes.START_REQUEST);
export const endRequest = () => action(ActionTypes.END_REQUEST);
export const downloadDocuments = () => action(ActionTypes.DOWNLOAD_DOCUMENTS);
export const fetchThumbnailsByEnvelope = (envelopeId: string, numberOfPages: number) =>
  action(ActionTypes.FETCH_THUMBNAILS_BY_ENVELOPE, { envelopeId, numberOfPages });
export const fetchThumbnailsByEnvelopeDone = (pageThumbnails: any) =>
  action(ActionTypes.FETCH_THUMBNAILS_BY_ENVELOPE_DONE, { pageThumbnails });
export const addBlocksToSigningExperience = (blockIds: number[]) =>
  action(ActionTypes.ADD_BLOCKS_TO_SIGNING_EXPERIENCE, { blockIds });
export const signingExperienceComplete = () => action(ActionTypes.SIGNING_EXPERIENCE_COMPLETE);
export const tabNextBlock = (
  currentIndex: number | null,
  blocks: IBlockState,
  groups?: IGroupState,
  completedIndex?: number
) => action(ActionTypes.TAB_NEXT_BLOCK, { currentIndex, blocks, groups, completedIndex });
export const tabToBlock = (nextIndex: number) => action(ActionTypes.TAB_TO_BLOCK, { nextIndex });
export const updateSigningExperienceBlock = (currentIndex: number, block?: IBlock) =>
  action(ActionTypes.UPDATE_SIGNING_EXPERIENCE_BLOCK, { currentIndex, block });
export const updateSigningExperienceblock = (currentIndex: number) =>
  action(ActionTypes.UPDATE_SIGNING_EXPERIENCE_BLOCK, { currentIndex });
export const downloadEnvelope = (
  envelopeId: string,
  signerId: string,
  fileName: string,
  alreadySigned: boolean,
  fileType: string
) => action(ActionTypes.DOWNLOAD_ENVELOPE, { envelopeId, signerId, fileName, alreadySigned, fileType });
export const downloadedEnvelope = (blobUrl: any, fileName: string, alreadySigned: boolean, fileType: string) =>
  action(ActionTypes.DOWNLOAD_ENVELOPE_DONE, { blobUrl, fileName, alreadySigned, fileType });
export const setPageDimensions = (height: number, width: number, fullPage: number) =>
  action(ActionTypes.SET_PAGE_DIMENSIONS, { height, width, fullPage });
export const setPageScale = (fullPage: number, pageScale: number) =>
  action(ActionTypes.SET_PAGE_SCALE, { fullPage, pageScale });
export const completeBlocksInGroup = (blocks: IBlock[]) => action(ActionTypes.COMPLETE_BLOCKS_IN_GROUP, {blocks});
export const setCurrentDocument = (documentId: string, documentName: string) => action(ActionTypes.SET_CURRENT_DOCUMENT, { documentId, documentName });
export const setPendingBlockInfo = (documentId: string, pageNumber: number, blockId: string) =>
  action(ActionTypes.SET_PENDING_BLOCK_INFO, { documentId, pageNumber, blockId });
export const updateSignerSigningSettings = (signingSettings: ISignatureSettings) => action(ActionTypes.UPDATE_SIGNER_SIGNING_SETTINGS, signingSettings)